'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sourceValues = exports.sources = exports.sourceKeys = undefined;

var _sources;

var _keyMirror = require('react-utils/keyMirror');

var _keyMirror2 = _interopRequireDefault(_keyMirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var sourceKeys = exports.sourceKeys = (0, _keyMirror2.default)({
  GENERAL: null,
  UPGRADE_BUTTON: null, // Will be deprecated
  USAGE_LIMIT: null,
  FEATURE_LIMIT: null, // Will be deprecated
  CHECKOUT: null,
  CONTACT_SALES: null,
  CONTACT_SALES_BUTTON: null,
  TRIAL: null, // Deprecated
  TRIAL_BUTTON: null,
  EXPIRED_TRIAL_MODAL: null,
  LOCKED_FEATURE: null,
  LOCKED_APP: null,
  PRODUCT_ACTIVATION: null,
  STANDALONE: null
});

var sources = exports.sources = (_sources = {}, _defineProperty(_sources, sourceKeys.GENERAL, 'general'), _defineProperty(_sources, sourceKeys.UPGRADE_BUTTON, 'upgrade-button'), _defineProperty(_sources, sourceKeys.USAGE_LIMIT, 'usage-limit'), _defineProperty(_sources, sourceKeys.FEATURE_LIMIT, 'feature-limit'), _defineProperty(_sources, sourceKeys.CHECKOUT, 'checkout'), _defineProperty(_sources, sourceKeys.CONTACT_SALES, 'contact-sales'), _defineProperty(_sources, sourceKeys.CONTACT_SALES_BUTTON, 'contact-sales-button'), _defineProperty(_sources, sourceKeys.TRIAL, 'trial'), _defineProperty(_sources, sourceKeys.TRIAL_BUTTON, 'trial-button'), _defineProperty(_sources, sourceKeys.EXPIRED_TRIAL_MODAL, 'expired-trial-modal'), _defineProperty(_sources, sourceKeys.LOCKED_FEATURE, 'locked-feature'), _defineProperty(_sources, sourceKeys.LOCKED_APP, 'locked-app'), _defineProperty(_sources, sourceKeys.PRODUCT_ACTIVATION, 'product-activation'), _defineProperty(_sources, sourceKeys.STANDALONE, 'standalone'), _sources);

var sourceValues = exports.sourceValues = Object.values(sources || {});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/common/data/upgradeData/properties/sources.js
// module id = 67
// module chunks = 3 4 5